class Dialog {
  constructor (router) {
    this.router = router;
  }

  names (paramName = "dialog") {
    const value = this.router.currentRoute.value.query[paramName];
    if (value === undefined) {
      return [];
    } else if (typeof value === "string") {
      return [value];
    } else {
      return value.slice();
    }
  }

  push (name, id = null, paramName = "dialog") {
    if (name.match(/^\//)) {
      return this.router.push({ path: name })
        .catch((e) => {
          if (!e.message.match(/navigation guard/)) {
            throw e;
          }
        });
    } else {
      const names = this.names(paramName);
      const updatedDialogParams = {};
      names.push(id ? `${name}/${id}` : name);
      updatedDialogParams[paramName] = names;
      this.router.updateQueryParams(updatedDialogParams);
    }
  }

  getStackIds (paramName = "dialog") {
    return this.names(paramName).map(name => {
      const slashIndex = name.indexOf("/");
      return slashIndex === -1 ? null : name.slice(slashIndex + 1);
    });
  }

  getId (paramName = "dialog") {
    const ids = this.getStackIds(paramName);
    return ids[ids.length - 1] || null;
  }

  pop (paramName = "dialog") {
    const names = this.names(paramName);
    const updatedDialogParams = {};
    names.pop();
    updatedDialogParams[paramName] = names;
    this.router.updateQueryParams(updatedDialogParams);
  }

  override (name, id = null, paramName = "dialog") {
    const updatedDialogParams = {};
    updatedDialogParams[paramName] = id ? `${name}/${id}` : name;
    this.router.updateQueryParams(updatedDialogParams);
  }

  close (paramName = "dialog") {
    return this.router.removeQueryParam(paramName);
  }
}

var Dialog$1 = Dialog;

export { Dialog$1 as default };
